// https://github.com/mattdesl/canvas-sketch-util

// https://github.com/mattdesl/canvas-sketch

const canvasSketch = require("canvas-sketch");
const { lerp, mod } = require("canvas-sketch-util/math");
const random = require("canvas-sketch-util/random");

random.setSeed(window.fxhash);

const features = {
  dimensions: random.weightedSet([
    {
      value: "landscape",
      weight: 100,
    },
    { value: "square", weight: 70 },
    { value: "portrait", weight: 50 },
  ]),
  colorMode: random.weightedSet([
    {
      value: "a",
      weight: 70,
    },
    { value: "b", weight: 100 },
  ]),
  gridSize: random.weightedSet([
    {
      value: "smol",
      weight: 50,
    },
    { value: "med", weight: 80 },
    { value: "xl", weight: 30 },
  ]),
  margin: random.weightedSet([
    {
      value: "smol",
      weight: 50,
    },
    { value: "med", weight: 80 },
    { value: "xl", weight: 50 },
  ]),
  scale: random.weightedSet([
    {
      value: "smol",
      weight: 20,
    },
    { value: "big", weight: 90 },
  ]),
  colorSet: random.weightedSet([
    { value: "cool", weight: 90 },
    { value: "green", weight: 20 },
  ]),
};

console.log(features.dimensions);
console.log(features.colorMode);
console.log(features.gridSize);

const settings = {
  // dimensions: "a4",
  dimensions: features.dimensions == "square" ? [800, 800] : "a4",
  orientation: features.dimensions == "portrait" ? "portrait" : "landscape",
  // pixelised: true,
};

// console.log(settings.dimensions, settings.orientation)

window.$fxhashFeatures = {
  ratio: features.dimensions,
  "color mode": features.colorMode,
  "grid size": features.gridSize,
  margin: features.margin,
  scale: features.scale,
};

const getGridSize = () => {
  switch (features.gridSize) {
    case "smol":
      return random.rangeFloor(4, 11);
    case "med":
      return random.rangeFloor(20, 40);
    case "xl":
      return random.rangeFloor(50, 100);
  }
};

const getMarginSize = () => {
  switch (features.margin) {
    case "smol":
      return 10;
    case "med":
      return 50;
    case "xl":
      return 150;
  }
};

const getColorPalette = () => {
  switch (features.colorSet) {
    case "cool":
      return ["deeppink", "black", "white", "blue"];
    case "green":
      return ["#55a54a"];
  }
};

const getPointScale = () => {
  switch (features.scale) {
    case "smol":
      return {
        radius: 0.01,
        max: 60,
      };
    case "big":
      return {
        radius: 0.08,
        max: 6,
      };
  }
};

const scales = getPointScale();

console.log(scales);

const mods = [
  // { name: "ok mountain 7ft", mods: [6, 56, 20] },
  // { name: "ok minimalistic geometry peak", mods: [0, 13, 15] },
  // { name: "superb cleaf", mods: [17, 53, 6] },
  { name: "superb tron epic", mods: [4, 0, 10] },
  // { name: "nice triangle piles", mods: [9, 30, 13] },
  // { name: "ok dunes", mods: [9, 30, 13] },
  // { name: "ok mntn", mods: [77, 80, 19] },
  // { name: "ok snow gorge", mods: [77, 80, 19] },
  // { name: "superb Euclid plateau", mods: [76, 66, 3] },
];

let [modA, modB, modC] = [4, 0, 10];

// bad
//{ name: "soso hacked mntn", mods: [2, 94, 5] },

// modA = Math.floor(Math.abs(random.gaussian()) * 10);
// modB = Math.floor(Math.abs(random.gaussian()) * 10);
// modC = Math.floor(Math.abs(random.gaussian()) * 10);

// modA = 12;
// modB = 1;
// modC = 6;

let colorMode = features.colorMode;

const sketch = ({ context, width, height }) => {
  const createGrid = (max) => {
    const points = [];
    const count = random.rangeFloor(1, max);
    for (let x = 0; x < count; x++) {
      for (let y = 0; y < count; y++) {
        const u = count <= 1 ? 0.5 : x / (count - 1);
        const v = count <= 1 ? 0.5 : y / (count - 1);

        const radius = Math.abs(random.gaussian() * scales.radius);
        points.push({
          radius,
          position: [u, v],
          // monocolored or no
          // colours?
          // green rare
          color: random.pick(getColorPalette()),
        });
      }
    }
    return points;
  };

  const direction = random.boolean();

  const index = (r, c) =>
    direction ? (r * width + c) << 2 : (r * width - c) << 2;
  const dither = (pixels, r, c, k) => {
    const i = index(r, c) + k;
    const v = pixels[i];
    const vn = 255 - v < 255 >> 1 ? 255 : 0;
    const rem = v - vn;
    pixels[i] = vn;
    if (c < width - 1) pixels[index(r, c + 1) + k] += (rem >> 4) * modA;

    if (r < height - 1 && c < width - 1)
      pixels[index(r + 1, c + 1) + k] += rem >> 4;
    if (r < height - 1) pixels[index(r + 1, c) + k] += (rem >> 4) * modB;
    if (r < height - 1 && c > 0)
      pixels[index(r + 1, c - 1) + k] += (rem >> 4) * modC;
  };

  let points;

  console.log(getGridSize());
  const createPoints = () => {
    points = createGrid(getGridSize()).filter(() => random.value() > 0.9);
    if (points.length < 2) {
      createPoints();
    }
    if (points.length > scales.max) {
      createPoints();
    }
  };
  createPoints();

  console.log(points.length);

  const margin = getMarginSize();

  let offset = margin;

  const manipulatePixels = () => {
    const data = context.getImageData(0, 0, width, height);

    for (let r = offset; r < height - offset; ++r)
      for (let c = offset; c < width - offset; ++c) {
        switch (colorMode) {
          case "a":
            dither(data.data, r, c, 1);
            break;

          case "b":
            dither(data.data, r, c, 0);
            dither(data.data, r, c, 2);
            dither(data.data, r, c, 1);
            break;

          case "c":
            dither(data.data, r, c, 0);
            dither(data.data, r, c, 1);
            break;
        }
      }
    context.putImageData(data, 0, 0);
  };

  return ({ context, width, height }) => {
    context.fillStyle = "#E1E1D1";
    context.fillRect(0, 0, width, height);

    points.forEach((data) => {
      const { radius, position, color } = data;
      const [u, v] = position;

      const x = lerp(margin, width - margin, u);
      const y = lerp(margin, height - margin, v);

      context.beginPath();
      context.arc(x, y, radius * width, 0, Math.PI * 2, false);
      context.fillStyle = color;
      context.fill();
    });

    manipulatePixels();
  };
};

canvasSketch(sketch, settings);
fxpreview();
